import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anon, object = user
    const [error, setError] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                setUser(data);
            } catch (_) {
                setUser(false);
            }
        })();
    }, []);

    async function login(email, password) {
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data);
            return true;
        } catch (e) {
            setError(formatApiError(e.response?.data?.detail) || e.message);
            return false;
        }
    }

    async function logout() {
        try {
            await api.post("/auth/logout");
        } catch (_) {}
        setUser(false);
    }

    return (
        <AuthContext.Provider value={{ user, login, logout, error, setError }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
